
export default {
  download: 'ダウンロードする',
}
